import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, ArrowRight, Sparkles } from 'lucide-react';
import { publicApi } from '../api';
import { useFetch } from '../useFetch';

const resolveImg = (src) => {
  if (!src) return '';
  if (src.startsWith('http')) return src;
  const base = process.env.REACT_APP_BACKEND_URL || '';
  return src.startsWith('/') ? `${base}${src}` : `${base}/${src}`;
};

export default function ItinerariesSection({ citySlug, limit = 6 }) {
  const { data: itineraries } = useFetch(
    `itineraries:${citySlug || 'all'}`,
    () => publicApi.itineraries(citySlug || undefined),
    [citySlug]
  );
  if (!itineraries || itineraries.length === 0) return null;
  const items = itineraries.slice(0, limit);

  return (
    <section className="mt-10 fade-in-up" data-testid="itineraries-section">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xs tracking-[0.3em] uppercase text-[color:var(--yup-primary)] font-semibold mb-1 flex items-center gap-2">
            <Compass size={14} /> Itinerari consigliati
          </h2>
          <p className="text-white/70 text-sm">Contenuti curati per te dalla redazione YUP</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((it, idx) => (
          <Link
            key={it.id}
            to={`/itinerari/${it.slug}`}
            className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-[color:var(--yup-primary)]/60 bg-black/40 transition-all fade-in-up"
            style={{ animationDelay: `${0.05 + idx * 0.06}s` }}
            data-testid={`itinerary-card-${it.slug}`}
          >
            {it.cover_image && (
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={resolveImg(it.cover_image)}
                  alt={it.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
            )}
            {it.sponsored && (
              <div className="absolute top-3 left-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-widest text-black"
                   style={{ background: 'linear-gradient(135deg, #f2e5b8, #BCAC8A)' }}>
                <Sparkles size={10}/> Sponsored
              </div>
            )}
            <div className="p-5">
              <h3 className="text-white font-bold text-lg leading-tight group-hover:text-[color:var(--yup-primary)] transition">{it.title}</h3>
              {it.subtitle && <p className="text-white/60 text-sm mt-2 line-clamp-2">{it.subtitle}</p>}
              <div className="mt-4 flex items-center gap-2 text-[color:var(--yup-primary)] text-xs tracking-widest uppercase font-semibold">
                Leggi <ArrowRight size={14} className="group-hover:translate-x-1 transition" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
